import React from 'react'
import PropTypes from 'prop-types'
import useKpiMeasures from '../../hooks/useKpiMeasures'
import Banner from '../ui/Banner'
import KpiCardGroup from '../ui/KpiCard/KpiCardGroup'

const ERROR_MESSAGE = 'Impossible de charger les indicateurs.'

const KpiCardsRow = ({
  collectId, gradeMax, hasAlertsConfigured, hasAdditionalAnswer, dateRange,
  operatorId, resourceIds, resourceSearch, variableId
}) => {
  const { values, error } = useKpiMeasures(collectId, null, {
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    operatorId,
    resourceIds,
    resourceSearch,
    variableId
  })

  if (error)
    return <Banner variant="danger">{ERROR_MESSAGE}</Banner>

  // No completed control on the period → nothing to show, every metric reads "--".
  const isEmpty = Number(values.controlsCount || 0) === 0

  return (
    <KpiCardGroup
      alertsCount={isEmpty ? null : values.alertsCount}
      controlsCount={isEmpty ? null : values.controlsCount}
      grade={isEmpty ? null : values.grade}
      gradeMax={gradeMax}
      hasAdditionalAnswer={hasAdditionalAnswer}
      hasAlertsConfigured={hasAlertsConfigured}
      satisfaction={isEmpty ? null : values.satisfaction}
    />
  )
}

KpiCardsRow.propTypes = {
  collectId: PropTypes.number.isRequired,
  dateRange: PropTypes.shape({
    endDate: PropTypes.string,
    startDate: PropTypes.string
  }).isRequired,
  gradeMax: PropTypes.number,
  hasAdditionalAnswer: PropTypes.bool,
  hasAlertsConfigured: PropTypes.bool,
  operatorId: PropTypes.string,
  resourceIds: PropTypes.arrayOf(PropTypes.number),
  resourceSearch: PropTypes.string,
  variableId: PropTypes.string
}

KpiCardsRow.defaultProps = {
  gradeMax: 1,
  hasAdditionalAnswer: false,
  hasAlertsConfigured: false,
  operatorId: '',
  resourceIds: [],
  resourceSearch: '',
  variableId: ''
}

export default KpiCardsRow
